<template>
  <div class="carousel" id="carousel">
    <div class="carousel-sides" id="folds" ref="folds">
      <div class="carousel-side-center" id="fold-center">
        <slot name="content"></slot>
      </div>
      <div class="carousel-side-top">
        <div class="carousel-side-top-inner" id="fold-top"></div>
      </div>
      <div class="carousel-side-bottom">
        <div class="carousel-side-bottom-inner" id="fold-bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const carousel = document.getElementById('carousel')
    const foldsWrapper = document.getElementById('folds')
    const center = document.getElementById('fold-center')
    const bottom = document.getElementById('fold-bottom')
    const top = document.getElementById('fold-top')

    let state = {
      disposed: false,
      targetScroll: 0,
      scroll: 0,
      mouse: {
        x: 0,
        y: 0
      },
      follower: {
        x: 0,
        y: 0
      },
      followerVelocity: {
        x: 0,
        y: 0
      }
    }

    function lerp(current, target, speed = 0.1, limit = 0.001) {
      let change = (target - current) * speed
      if (Math.abs(change) < limit) {
        change = target - current
      }
      return change
    }

    class FoldedDom {
      constructor(wrapper, folds = null) {
        this.wrapper = wrapper
        this.folds = folds

        this.scale = [1, 1]
      }
      updateFoldTransforms() {
        let y, x

        x = state.follower.x * window.innerWidth * 0.12
        y = state.follower.y * window.innerHeight * 0.2

        foldsWrapper.style.transform = `translate(${x}px, ${y}px)`

        const xOrigin = state.follower.x * 100 + 50
        const yOrigin = state.follower.y * 100 + 50

        center.style.perspectiveOrigin = `${xOrigin}% ${yOrigin}%`

        this.scale = []
        let scales = this.scale

        function getTransform(from, to, reverseRotation = false) {
          let relX = to.x - from.x
          let relY = to.y - from.y
          let relZ = to.z - from.z

          let xAngle = Math.atan2(relZ, relY)
          if (reverseRotation) {
            xAngle = Math.atan2(relY, relZ)
          }

          let xAngleDegrees = (xAngle / Math.PI) * 180
          if (reverseRotation) {
            xAngleDegrees = -xAngleDegrees - 90
          }

          const zyLength = length(relZ, relY)
          let scale = (zyLength / carousel.clientHeight) * 1.2

          let skewAngle = Math.atan2(-relY, relX)
          let skewAngleDegrees = ((skewAngle + Math.PI / 2) / Math.PI) * 180
          scales.push(1 / scale)

          return `skewX(${skewAngleDegrees}deg) rotate3d(1,0, 0,${xAngleDegrees +
            0}deg) scale3d(1,${scale},1)`
        }

        let wrapperRect = carousel.getBoundingClientRect()
        let centerRect = center.getBoundingClientRect()

        const centerX =
          centerRect.left - wrapperRect.left + centerRect.width / 2

        const centerYtop = centerRect.top
        const centerYbottom =
          centerRect.top - wrapperRect.top + centerRect.height
        const centerZ = 0

        let toX = wrapperRect.width / 2
        let topY = wrapperRect.top
        let bottomY = wrapperRect.height
        let toZ = wrapperRect.height

        let bottomTransform = getTransform(
          {
            x: centerX,
            y: centerYbottom,
            z: centerZ
          },
          {
            x: toX,
            y: bottomY,
            z: toZ
          }
        )
        let topTransform = getTransform(
          {
            x: centerX,
            y: centerYtop,
            z: centerZ
          },
          {
            x: toX,
            y: topY,
            z: toZ
          },
          true
        )

        bottom.style.transform = bottomTransform
        top.style.transform = topTransform
      }
    }
    const length = (x, y, z = 0) => Math.sqrt(x * x + y * y + z * z)

    let insideFold

    let tick = () => {
      if (state.disposed) return

      // Make it mouse bouncy with a spring
      let spring = 0.03
      let friction = 0.75

      let relMouse = {
        x: (state.mouse.x - state.follower.x) * spring,
        y: (state.mouse.y - state.follower.y) * spring
      }
      state.followerVelocity.x =
        (state.followerVelocity.x + relMouse.x) * friction
      state.followerVelocity.y =
        (state.followerVelocity.y + relMouse.y) * friction
      state.follower.x += state.followerVelocity.x
      state.follower.y += state.followerVelocity.y

      state.targetScroll = -(
        document.documentElement.scrollTop || document.body.scrollTop
      )

      state.scroll += lerp(state.scroll, state.targetScroll, 0.1, 0.0001)

      insideFold.updateFoldTransforms()

      requestAnimationFrame(tick)
    }

    let onMouseMove = ev => {
      state.mouse.x = ev.clientX / window.innerWidth
      state.mouse.y = ev.clientY / window.innerHeight

      let mouseX = state.mouse.x * 2 - 1
      let mouseY = state.mouse.y * 2 - 1

      let mouseLen = Math.min(0.5, length(mouseX, mouseY))
      let mouseAngle = Math.atan2(mouseY, mouseX)

      state.mouse.x = Math.cos(mouseAngle) * mouseLen
      state.mouse.y = Math.sin(mouseAngle) * mouseLen
    }
    let onTouchMove = ev => {
      onMouseMove(ev.touches[0])
    }

    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('touchmove', onTouchMove)

    insideFold = new FoldedDom(foldsWrapper, [top, center, bottom])
    tick()
  }
}
</script>

<style lang="scss">
.carousel {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 204px);
  overflow: hidden;
}

.carousel-sides {
  position: relative;
  transform-style: preserve-3d;
}

.carousel-side-center {
  position: relative;
  height: calc((100vh - 204px) / 1.5);
  width: calc(58vw - 15px);
  background: pink;
  transform: translateZ(1000px);
  perspective: calc((100vh - 204px) * 1.4);

  @media screen and (min-width: 1200px) {
    width: calc(1170px * 0.58);
  }
}

.carousel-side-top,
.carousel-side-bottom {
  position: absolute;
  left: 0;
  right: 0;
  perspective: calc((100vh - 204px) * 1.4);
  transform-style: preserve-3d;
}

.carousel-side-top {
  bottom: 100%;
  perspective-origin: 50% 100%;
}

.carousel-side-bottom {
  top: 100%;
  perspective-origin: 50% 0%;
}

.carousel-side-top-inner,
.carousel-side-bottom-inner {
  height: calc((100vh - 204px) / 2);
  width: 100%;
  background-image: linear-gradient(160deg, #37ff9d 0%, #ff3777 60%);
}

.carousel-side-top-inner {
  transform-origin: bottom center;
}

.carousel-side-bottom-inner {
  transform-origin: top center;
}

.carousel-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  perspective: calc((100vh - 204px) * 1.4);
  perspective-origin: 100% 50%;
  transform: translateZ(1000px);
}

.carousel-slide {
  display: none;
}
</style>
